import { TASTING_STOPS as _ALL_TASTING_STOPS } from './tastingStops';
import { ACCOMMODATIONS as _ALL_ACCOMMODATIONS } from './accommodations';

export const TASTING_STOPS = _ALL_TASTING_STOPS.filter((stop) => stop.verified);
export const ACCOMMODATIONS = _ALL_ACCOMMODATIONS.filter((stay) => stay.verified);

export const ALL_TASTING_STOPS = _ALL_TASTING_STOPS;
export const ALL_ACCOMMODATIONS = _ALL_ACCOMMODATIONS;
